import React from "react";
import WorkspaceInternalControls from "../libraries/WorkspaceInternalControls";

interface DepreciationInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function DepreciationInternalControls({ onBack, setActiveSection, controlsListSection }: DepreciationInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Depreciation"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}


